import { Button, makeStyles } from "@material-ui/core";

import { useEffect } from "react";
import { useDataLayerValue } from "../../Reducer/DataLayer";
import addAutoplay from "../../_utils/ytAutoplay";

const Card220 = ({ index, news }) => {
  const classes = useStyles();

  const [{}, dispatch] = useDataLayerValue();

  useEffect(() => {
    const getAutoplay = async () => {
      let newYT = await addAutoplay(news?.yt_embeded_link);

      news?.yt_embeded_link
        ? (document.getElementById("yt_embeded_video").innerHTML = `${newYT}`)
        : (document.getElementById(
            "yt_embeded_video"
          ).innerHTML = `<h3>Video is not avialable</h3>`);
    };

    getAutoplay();
  }, [news?.yt_embeded_link]);

  return (
    <div className={classes.cardBox} >
      <div className={classes.embeded} id="yt_embeded_video"></div>
      <div className={classes.content}>
        <h4 className="heading">{news?.heading}</h4>
        <div className="text">
          {news?.contents?.map((val, index) => (
            <div key={index}>
              {val} <br />
            </div>
          ))}
          <div className="d-flex  justify-content-center">
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: "1rem" }}
              onClick={() => (window.location = "/edit/" + news?.news_id)}
            >
              EDIT
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={async () => {
                const res = await fetch(
                  `/.netlify/functions/server/api/deleteNews/${news?.news_id}`,
                  {
                    method: "DELETE",
                    headers: { "Content-Type": "application/json" },
                  }
                );
                if (res.length !== 0)
                  dispatch({
                    type: "DELETE_NEWS",
                    payload: { newsId: news?.news_id },
                  });
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card220;

const useStyles = makeStyles((theme) => ({
  cardBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: ".5rem",
    boxShadow: "1px -1px 12px #a1a1a1, -1px 1px 12px #a1a1a1",
    borderRadius: ".75rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      width: "inherit",
      maxWidth: "inherit",
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    width: "40rem",
    borderRadius: "0 0 .75rem .75rem ",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "inherit",
      maxWidth: "inherit",
    },
    "& .heading": {
      backgroundColor: "#fafafa",
      height: "4rem",
      padding: "0.5rem",
      fontWeight: "bold",
    },
    "& .text": {
      flex: 1,
      backgroundColor: "#fff",
      margin: "1rem 0.5rem",
    },
  },
  embeded: {
    display: "flex",
    flexDirection: "column",
    margin: 0,
    alignItems: "center",
    backgroundColor: "#f2f4fc",
    borderRadius: ".75rem .75rem 0 0",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "& iframe": {
      width: "40rem",
      height: "20rem",
      aspectRatio: "16/9",
      [theme.breakpoints.down("sm")]: {
        width: "inherit",
        height: "inherit",
      },
    },
    "& h3": {
      width: "inherit",
      height: "inherit",
      display: "grid",
      placeItems: "center",
    },
  },
}));
